import * as z from "zod/v4";

export const getGoogleAdsUserLists = {
  name: "getGoogleAdsUserLists" as const,
  input: z.object({ customerId: z.string() }),
  output: z.object({
    userLists: z.array(z.object({ name: z.string(), id: z.string() })),
  }),
};
